import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

const styles = {
  AccordionWrapper: {
    ph: 24,
    pv: 16,
    width: '100%',
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: 'LIGHTEST_GREY',
    textAlign: 'center',
    underlayColor: 'LIGHTEST_GREY_2',
  } as BoxProps,
  boldHeaderText: {
    type: 'body12',
    fontSize: 12,
    textAlign: 'left',
    fontFamily: 'jiotype-bold',
    color: 'BLACK_21',
  } as TextNewProps,
  subTitleText: {
    type: 'body12',
    fontSize: 12,
    textAlign: 'left',
    color: 'BLACK_71' as ColorOptions,
  } as TextNewProps,
  amountText: {
    type: 'body12',
    fontSize: 12,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
  } as TextNewProps,
  lightColoredDesc: {
    type: 'body12',
    fontSize: 12,
    color: 'PRIMARY_GREY' as ColorOptions,
    textAlign: 'left',
    lineHeight: 14,
    fontFamily: 'jiotype-MEDIUM',
  } as TextNewProps,
  invoiceText: {
    type: 'body12',
    fontSize: 12,
    color: 'ORANGE_4A' as ColorOptions,
    textAlign: 'center',
    lineHeight: 14,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  expandedListHeader: {
    type: 'body12',
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  expandedListKey: {
    type: 'body12',
    fontSize: 12,
    color: 'PRIMARY_GREY' as ColorOptions,
    textAlign: 'left',
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  expandedListDetails: {
    type: 'body12',
    fontSize: 12,
    color: 'GREY_90' as ColorOptions,
    textAlign: 'left',
    fontWeight: '300',
  } as TextNewProps,
  listHeaderStyle: {
    type: 'body12',
    fontSize: 12,
    color: 'BLACK_21',
    textAlign: 'left',
    fontFamily: 'jiotype-bold',
  } as TextNewProps,
  SUCCESS: {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  PAID: {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  INVOICED: {
    backgroundColor: 'RED_BG_C' as ColorOptions,
  } as BoxProps,
  FAILED: {
    backgroundColor: 'RED_BG_C' as ColorOptions,
  } as BoxProps,
  SUSPENDED: {
    backgroundColor: 'ORANGE_BG_C' as ColorOptions,
  } as BoxProps,
  PENDING: {
    backgroundColor: 'ORANGE_BG_C' as ColorOptions,
  } as BoxProps,
  CANCELED: {
    backgroundColor: 'RED_BG_C' as ColorOptions,
  } as BoxProps,
  ACTIVE: {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  'IN PROGRESS': {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  FULFILLED: {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  INITIATED: {
    backgroundColor: 'GREEN_BG_C' as ColorOptions,
  } as BoxProps,
  refundStyles: {
    alignSelf: 'flex-end',
    justify: 'flex-end',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    underlayColor: 'BLUE',
    backgroundColor: 'BLUE',
  } as BoxProps,
  listItemContainer: {
    flexDirection: 'row',
    ph: 16,
    pv: 8,
    justify: 'space-between',
    borderRadius: 4,
  } as BoxProps,
  flatlist: {
    flexGrow: 1,
  } as ViewStyle,
}

export { styles }
